import React, { useEffect, useState } from "react";
import "./navbar.css";
import {
  Container,
  Nav,
  NavDropdown,
  Navbar,
  Offcanvas,
} from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { Fade } from "react-awesome-reveal";
const Navbarr = ({ userData }) => {
  const location = useLocation();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  //  function scrollToElement() {
  //     const home =document.getElementById("home");
  //   const contsctus =document.getElementById("contsctus");
  //   const about =document.getElementById("about");
  //   const important =document.getElementById("important");
  //   const service =document.getElementById("service");
  //     if (home) {
  //       home.scrollIntoView({ behavior: 'smooth' });
  //     }
  //     if (service) {
  //       service.scrollIntoView({ behavior: 'smooth' });
  //     }
  //     if (important) {
  //       important.scrollIntoView({ behavior: 'smooth' });
  //     }
  //     if (about) {
  //       about.scrollIntoView({ behavior: 'smooth' });
  //     }
  //     if (contsctus) {
  //       contsctus.scrollIntoView({ behavior: 'smooth' });
  //     }
  //   }
  const activeLink = () => {
    const link = document.querySelectorAll(".navbar-style .nav-link");
    link.forEach((act) => {
      act.addEventListener("click", function () {
        link.forEach((btn) => btn.classList.remove("active"));
        this.classList.add("active");
      });
    });
  };
  useEffect(() => {
    // scrollToElement()
    activeLink();
  }, []);
  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    window.location.href = "/";
  };
  useEffect(() => {
    if (location && location.pathname !== "/") {
      setShow(false);
    }
  }, [location]);
  return (
    <>
      <Navbar expand="lg" className="bg-body-tertiary">
        <Container>
          {userData && userData.user_type === "admin" ? null : userData &&
            userData.user_type === "consultant" ? null : (
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
          )}
          {userData && userData.user_type === "admin" ? (
            <i
              style={{ fontSize: "25px", cursor: "pointer" }}
              onClick={handleShow}
              className="fa-solid fa-bars"
            ></i>
          ) : userData && userData.user_type === "consultant" ? (
            <i
              style={{ fontSize: "25px", cursor: "pointer" }}
              onClick={handleShow}
              className="fa-solid fa-bars"
            ></i>
          ) : null}
          <Navbar.Brand>
            {userData && userData.username ? (
              <NavDropdown title={userData.username} id="basic-nav-dropdown">
                <NavDropdown.Item
                  as={Link}
                  to={
                    userData.user_type === "admin"
                      ? "/admin/profile"
                      : userData.user_type === "consultant"
                      ? "/consultant/profile"
                      : "/user/profile"
                  }
                >
                  الصفحة الشخصية
                </NavDropdown.Item>
                {/* <NavDropdown.Item href="#action/3.2">
                Another action
              </NavDropdown.Item> */}
                <button className="buttonadd" onClick={logout}>
                  تسجيل الخروج{" "}
                </button>
                {/* <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#action/3.4">
                Separated link
              </NavDropdown.Item> */}
              </NavDropdown>
            ) : (
              <Nav.Link as={Link} to="/register">
                إنشاء حساب
              </Nav.Link>
            )}
          </Navbar.Brand>

          <Navbar.Collapse id="basic-navbar-nav">
            {userData && userData.user_type === "client" ? (
              <Nav className="navbar-style">
                <Nav.Link className={`${window.location.pathname==='/user/services'?'active':''}`} as={Link} to={"/user/services"}>
                  الرئيسية
                </Nav.Link>
                <Nav.Link className={`${window.location.pathname==='/user/requestsuser'?'active':''}`} as={Link} to={"/user/requestsuser"}>
                  خدماتي
                </Nav.Link>
                {/* <Nav.Link href={"/#important"}></Nav.Link>
              <Nav.Link href="/#about">من نحن</Nav.Link>
              <Nav.Link href="/#contsctus">تواصل معاً</Nav.Link> */}

                {/* <Nav.Link href="#link">Link</Nav.Link> */}
              </Nav>
            ) : userData && userData.user_type === "admin" ? (
              <div>
                <Offcanvas className="lli" show={show} onHide={handleClose}>
                  <Offcanvas.Header closeButton>
                    <Offcanvas.Title>VIP</Offcanvas.Title>
                  </Offcanvas.Header>
                  <Offcanvas.Body>
                    <Fade direction="right" triggerOnce="false">
                      <div className="links">
                        <Link to="/admin/employee">إدارة الموظفين</Link>

                        <Link to="/admin/cars">السيارات</Link>

                        <Link to="/admin/requests">الطلبات</Link>

                        <Link to="/admin/paymenmethod">طرق الدفع</Link>

                        <Link to="/admin/touristtype">إدارة السياحه</Link>
                        <Link to="/admin/ads">إدارة الأعلانات</Link>

                        {/* <Link to="/admin/cars">السيارات</Link>
                        <Link to="/admin/tashel">تسهيل اوراق</Link>
                        <Link to="/admin/takhles">تخليص معاملات </Link>
                        <Link to="/admin/banoq">بنوك</Link>
                        <Link to="/admin/tourism">السياحة</Link>
                        <Link to="/admin/shahraqar">الشهر العقاري</Link> */}
                      </div>
                    </Fade>
                  </Offcanvas.Body>
                </Offcanvas>
              </div>
            ) : userData && userData.user_type === "consultant" ? (
              <div>
                <Offcanvas className="lli" show={show} onHide={handleClose}>
                  <Offcanvas.Header closeButton>
                    <Offcanvas.Title>VIP</Offcanvas.Title>
                  </Offcanvas.Header>
                  <Offcanvas.Body>
                    <Fade direction="right" triggerOnce="false">
                      <div className="links">
                        <Link to="/consultant/requests">الطلبات</Link>
                      </div>
                    </Fade>
                  </Offcanvas.Body>
                </Offcanvas>
              </div>
            ) : (
              <Nav className="navbar-style">
                <Nav.Link className="active" href={"/#home"}>
                  الرئيسية
                </Nav.Link>
                <Nav.Link href={"/#service"}>الخدمات</Nav.Link>
                <Nav.Link href={"/#important"}>اهم المميزات</Nav.Link>
                <Nav.Link href="/#about">من نحن</Nav.Link>
                <Nav.Link href="/#contsctus">تواصل معاً</Nav.Link>
              </Nav>
            )}
          </Navbar.Collapse>
          <Navbar.Brand href="/#home">
            <img src="logo.png" alt="" />
          </Navbar.Brand>
        </Container>
      </Navbar>
    </>
  );
};

export default Navbarr;
